export default "__VITE_ASSET__B6loLQ8$__"